import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { Auth, I18n } from 'aws-amplify';
import { Link } from 'react-router-dom';

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  formControl: {
    margin: theme.spacing.unit,
  },
  root: {
    color: '',
    '&$checked': {
      color: '#1a66ff',
    },
  },
  checked: {},
});

class EditPersonalData extends React.Component {
  constructor(props) {
    super(props);
    this.isIndividual = false;
    this.isDisabled = true;
    if (this.props.userProf) {
      const orgStr = this.props.userProf.hasOwnProperty('custom:organization')
        ? this.props.userProf['custom:organization']
        : '';
      const orgType = orgStr ? 'corporation' : 'individual';
      this.state = {
        ...this.props.userProf,
        orgRadio: orgType,
        updateError: '',
      };
    } else {
      this.state = {
        orgRadio: 'corporation',
        updateError: '',
        family_name: '',
        given_name: '',
        'custom:furigana_family': '',
        'custom:furigana_given': '',
        'custom:organization': '',
        'custom:furigana_org': '',
      };
    }
    this.errorState = {
      name: false,
      orgname: false,
    };
  }
  checkUser() {
    const that = this;
    return Auth.currentAuthenticatedUser()
      .then((user) => {
        if (!that._isMounted) {
          return;
        }
        Auth.userAttributes(user)
          .then((attrRet) => {
            // ログイン済みで正しくトークンが生きている
            if (this.state.family_name === '') {
              // 名字がないのであれば、このクラスにuser.attributesが存在しないものとみなす
              let userData = {};
              for (let i = 0; i < attrRet.length; i++) {
                let name = attrRet[i].Name;
                userData[name] = attrRet[i].Value;
              }
              const orgStr = userData.hasOwnProperty('custom:organization')
                ? userData['custom:organization']
                : '';
              const orgType = orgStr ? 'corporation' : 'individual';
              this.setState({
                ...userData,
                updateError: '',
                orgRadio: orgType,
              });
            }
            return;
          })
          .catch((attrErr) => {
            // トークンが死んでいる可能性がある
            Auth.signOut().then(() => {
              window.history.pushState('', '', '/');
              this.props.authStateChange('signIn');
            });
          });
      })
      .catch((err) => {
        if (!that._isMounted) {
          return;
        }
        Auth.signOut().then(() => {
          window.history.pushState('', '', '/');
          this.props.authStateChange('signIn');
        });
      });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.checkUser();
  }
  handleChange = (name) => (event) => {
    this.setState({
      [name]: event.target.value,
    });
  };
  isTextEmpty = (name) => {
    return this.state[name] === '' ? true : false;
  };
  updateOrg = (type) => {
    // indi, corpのどっちかが来る
    this.setState({
      orgRadio: type,
      updateError: '',
    });
  };
  validateByJa = () => {
    if (
      !this.isTextEmpty('family_name') &&
      !this.isTextEmpty('given_name') &&
      !this.isTextEmpty('custom:furigana_family') &&
      !this.isTextEmpty('custom:furigana_given')
    ) {
      this.errorState.name = false;
    } else {
      this.errorState.name = true;
    }
    if (this.state.orgRadio === 'corporation') {
      if (
        !this.state.hasOwnProperty('custom:organization') ||
        !this.state.hasOwnProperty('custom:furigana_org')
      ) {
        this.errorState.orgname = true;
        return;
      }
      if (!this.isTextEmpty('custom:organization') && !this.isTextEmpty('custom:furigana_org')) {
        this.errorState.orgname = false;
      } else {
        this.errorState.orgname = true;
      }
    } else {
      this.errorState.orgname = false;
    }
  };
  validateByEn = () => {
    if (!this.isTextEmpty('family_name') && !this.isTextEmpty('given_name')) {
      this.errorState.name = false;
    } else {
      this.errorState.name = true;
    }
    if (this.state.orgRadio === 'corporation') {
      if (!this.state.hasOwnProperty('custom:organization')) {
        this.errorState.orgname = true;
        return;
      }
      if (!this.isTextEmpty('custom:organization')) {
        this.errorState.orgname = false;
      } else {
        this.errorState.orgname = true;
      }
    } else {
      this.errorState.orgname = false;
    }
  };
  makeParam = () => {
    const orgStr = this.state.orgRadio === 'individual' ? '' : this.state['custom:organization'];
    const orgFuriganaStr =
      this.state.orgRadio === 'corporation' && window.LAPLACEID_LOCALE === 'ja'
        ? this.state['custom:furigana_org']
        : '';
    const furiganaGiven =
      window.LAPLACEID_LOCALE === 'ja' ? this.state['custom:furigana_given'] : '';
    const furiganaFamily =
      window.LAPLACEID_LOCALE === 'ja' ? this.state['custom:furigana_family'] : '';
    const res = {
      family_name: this.state.family_name,
      given_name: this.state.given_name,
      'custom:furigana_family': furiganaFamily,
      'custom:furigana_given': furiganaGiven,
      'custom:organization': orgStr,
      'custom:furigana_org': orgFuriganaStr,
    };
    return res;
  };
  update = () => {
    let param = this.makeParam();
    Auth.currentAuthenticatedUser()
      .then((result) => {
        Auth.updateUserAttributes(result, param)
          .then((updResult) => {
            Auth.userAttributes(result).then((attributes) => {
              const userData = {};
              attributes.forEach(({ Name, Value }) => {
                userData[Name] = Value;
              });
              this.props.update(userData);
              const tmpStr = 'Setting is updated';
              this.setState({
                ...userData,
                updateError: tmpStr
              });
              this.props.updateHeader('userProf');
            }).catch((attrErr) => {
              console.log('attrErr');
              console.log(attrErr);
            });
          })
          .catch((attrErr) => {
            // トークンが死んでいる可能性がある
            Auth.signOut().then(() => {
              window.history.pushState('', '', '/');
              this.props.authStateChange('signIn');
            });
          });
      })
      .catch((err) => {
        Auth.signOut().then(() => {
          window.history.pushState('', '', '/');
          this.props.authStateChange('signIn');
        });
      });
  };
  back = () => {
    this.checkUser();
    this.props.history.push('/');
  };
  showNameFurigana = (classes) => {
    if (window.LAPLACEID_LOCALE === 'ja') {
      return (
        <dl className='mypageInputFlex'>
          <dt>
            <Typography>
              お名前 (フリガナ)<span className='requiredIcon'>{I18n.get('Required')}</span>
            </Typography>
          </dt>
          <dd>
            <FormControl className={classes.formControl}>
              <input
                className='mypageInputStyle'
                id='furiganaFamily'
                onChange={this.handleChange('custom:furigana_family')}
                placeholder={I18n.get('Last name furigana')}
                value={this.state['custom:furigana_family']}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <input
                className='mypageInputStyle'
                id='familynamefurigana'
                onChange={this.handleChange('custom:furigana_given')}
                placeholder={I18n.get('First name furigana')}
                value={this.state['custom:furigana_given']}
              />
            </FormControl>
          </dd>
        </dl>
      );
    } else {
      return;
    }
  };
  showOrganizationFurigana = (classes) => {
    if (window.LAPLACEID_LOCALE === 'ja') {
      return (
        <dl className='mypageInputFlex'>
          <dt>
            <Typography>
              法人名 (フリガナ)<span className='requiredIcon'>{I18n.get('Required')}</span>
            </Typography>
          </dt>
          <dd>
            <FormControl className={classes.formControl}>
              <input
                className='mypageInputStyle large'
                id='orgFurigana'
                onChange={this.handleChange('custom:furigana_org')}
                placeholder={I18n.get('organization furigana')}
                value={this.state['custom:furigana_org']}
              />
            </FormControl>
          </dd>
        </dl>
      );
    } else {
      return;
    }
  };
  showUpdateMessage = (text) => {
    if (text === 'Setting is updated') {
      return <Typography className='mypageUpdateText'>{I18n.get(text)}</Typography>;
    } else {
      return <Typography className='mypageErrorText editPersonalData'>{I18n.get(text)}</Typography>;
    }
  };
  render() {
    const { classes } = this.props;
    if (window.LAPLACEID_LOCALE === 'ja') {
      this.validateByJa();
    } else {
      this.validateByEn();
    }
    this.isDisabled = !this.errorState.name && !this.errorState.orgname ? false : true;
    return (
      <div className='mypageContainer'>
        <div className='mypageBreadcrumbs'>
          <Link to='/'>{I18n.get('User profile')}</Link>&nbsp;&nbsp;＞&nbsp;&nbsp;
          {I18n.get('Edit personal data')}
        </div>
        <p className='mypageTitle'>
          <span className='mypageTitleIcon'></span>
          {I18n.get('Edit personal data')}
        </p>
        <div className='mypageUserinfoItem'>
          <dl className='mypageInputFlex'>
            <dt>
              <Typography>
                {I18n.get('Name')}
                <span className='requiredIcon'>{I18n.get('Required')}</span>
              </Typography>
            </dt>
            <dd>
              <FormControl className={classes.formControl}>
                <input
                  className='mypageInputStyle'
                  id='familyName'
                  onChange={this.handleChange('family_name')}
                  placeholder={I18n.get('Last name')}
                  value={this.state.family_name}
                />
              </FormControl>
              <FormControl className={classes.formControl}>
                <input
                  className='mypageInputStyle'
                  id='givenName'
                  onChange={this.handleChange('given_name')}
                  placeholder={I18n.get('First name')}
                  value={this.state.given_name}
                />
              </FormControl>
            </dd>
          </dl>
          {this.showNameFurigana(classes)}
          <dl className='mypageInputFlex'>
            <dt>
              <Typography>
                {I18n.get('Business')}/{I18n.get('Private')}
                <span className='requiredIcon'>{I18n.get('Required')}</span>
              </Typography>
            </dt>
            <dd className='mypageRadiobutton'>
              <FormControl component='fieldset' className={classes.formControl}>
                <RadioGroup
                  className={classes.group}
                  value={this.state.orgRadio}
                  onChange={this.handleChange('orgRadio')}
                >
                  <FormControlLabel
                    value='corporation'
                    control={<Radio classes={{ root: classes.root, checked: classes.checked }} />}
                    label={I18n.get('Business')}
                  />
                  <FormControlLabel
                    value='individual'
                    control={<Radio classes={{ root: classes.root, checked: classes.checked }} />}
                    label={I18n.get('Private')}
                  />
                </RadioGroup>
              </FormControl>
            </dd>
          </dl>
          <div style={{ display: this.state.orgRadio === 'individual' ? 'none' : '' }}>
            <dl className='mypageInputFlex'>
              <dt>
                <Typography>
                  {I18n.get('Company/Institution name')}
                  <span className='requiredIcon'>{I18n.get('Required')}</span>
                </Typography>
              </dt>
              <dd>
                <FormControl className={classes.formControl}>
                  <input
                    className='mypageInputStyle large'
                    id='organization'
                    onChange={this.handleChange('custom:organization')}
                    placeholder={I18n.get('Company/Institution name')}
                    value={this.state['custom:organization']}
                  />
                </FormControl>
              </dd>
            </dl>
            {this.showOrganizationFurigana(classes)}
          </div>
          {this.showUpdateMessage(this.state.updateError)}
          <Button
            className='mypageLargeButton blue editPersonalData'
            onClick={this.update}
            variant='contained'
            color='secondary'
            disabled={this.isDisabled}
          >
            {I18n.get('Save')}
          </Button>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(EditPersonalData);
